import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { useSplitIoStore } from '@centric-os/stores/splitio/use-split-io';
import { FeatureFlags } from '@centric-os/types';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../../enums';

const Component = () => import('./MealPlanHealth.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.MEAL_PLAN_HEALTH),
  name: SitesRouteNames.SITE_MEAL_PLAN_HEALTH,
  component: Component,
  beforeEnter: async (to) => {
    const splitIo = useSplitIoStore();
    await splitIo.fetchFeatureFlags();

    if (splitIo.isFeatureOn(FeatureFlags.MEALPLAN_HEALTH)) return true;

    return {
      name: SitesRouteNames.SITE_FINANCIAL_CONFIG,
      params: { siteId: to.params.siteId },
    };
  },
} as RouteRecordRaw;
